export const USER_PROFILE_TABS = {
  stats: "stats",
  achievements: "achievements",
  vodaBucks: "vodabucks",
  recentActivity: "recentActivity",
};
